import { MenuItem, ModifierDetail, ModifierGroupWrapper } from '@core/models';
import { CartPriceField } from '../types/cart-price-field.type';

export function calculateCartItemSubtotal(item: MenuItem, priceField: CartPriceField): bigint {
	const unitPrice = item[priceField] ?? 0n;
	const quantity = item.cantidad ?? 1n;

	return BigInt(unitPrice) * BigInt(quantity);
}

export function calculateCartSubtotalByField<
	T extends keyof ModifierDetail | keyof MenuItem
>(menuItem: MenuItem, field: T): bigint {
	const price = BigInt((menuItem[field as keyof MenuItem] ?? 0n) as number);

	const detailsWithQuantity = (menuItem.gruposModificadores ?? [])
		.flatMap((group: ModifierGroupWrapper) => group.grupoModificador.detallesmodificadores)
		.filter((detail: ModifierDetail) => detail?.addExtra);

	const totalExtras = detailsWithQuantity.reduce((sum: bigint, detail: ModifierDetail) => {
		const itemPrice = detail.isFree
			? 0n
			: BigInt((detail[field as keyof ModifierDetail] ?? 0n) as number);
		const extraQuantity = BigInt(detail.cantidad ?? 0n);
		const extraPrice =
			extraQuantity > 0n
				? BigInt((detail[field as keyof ModifierDetail] ?? 0n) as number) * extraQuantity
				: 0n;

		return sum + itemPrice + extraPrice;
	}, 0n);

	return price + totalExtras;
}

export function calculateModifierDisplayPrice(detail: ModifierDetail): bigint {
	if (!detail) return 0n;

	const baseSelectionPrice = detail.isFree ? 0n : BigInt(detail.precio ?? 0n);
	const extraQuantity = BigInt(detail.cantidad ?? 0n);
	const extraPrice =
		extraQuantity > 0n ? BigInt(detail.precio ?? 0n) * extraQuantity : 0n;

	return baseSelectionPrice + extraPrice;
}

export function calculateModifierDisplayQuantity(detail: ModifierDetail): number {
	if (!detail?.cantidad) return 1;
	return Number(detail.cantidad) + 1;
}
